import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Flex, Text } from '@rover/kibble/core';
import theme from '@rover/kibble/tokens/build/rover/es6/theme';
import { TrainerFlairSlugEnum } from '@rover/rsdk/src/apiClient/latest/model/trainerFlairSlugEnum';

import { getFlairIconBySlug } from './utils';

interface TrainerFlairProps {
  slug: TrainerFlairSlugEnum;
  displayText: string;
}
export default function TrainerFlair({ slug, displayText }: TrainerFlairProps): JSX.Element {
  const flairIcon = getFlairIconBySlug(slug);

  return (
    <Flex
      data-testid="trainer-flair"
      sx={{ padding: '4px 6px', boxSizing: 'content-box' }}
      minHeight="18px"
      backgroundColor={theme.colors.green['100']}
      borderRadius="4px"
      gap="8px"
      alignItems="center"
      width="fit-content"
    >
      <FontAwesomeIcon
        icon={flairIcon}
        color={theme.colors.green['500']}
        height="14px" // Using font size instead of height causes CLS issues
        widthAuto
        overflow="visible" // Font Awesome seems to be doing weird stuff with SVG path sizing
      />
      <Text size="100" fontWeight="semibold" textColor="primary">
        {displayText}
      </Text>
    </Flex>
  );
}
